import { createContext, useContext } from 'react'

/**
 * Id of the competition the players on screen are expected to play in. Player
 * cards compare it with the competition of the player's current team to show
 * "No está en la liga" when the player has left it (no team, or a team that
 * plays in another competition, e.g. a player who moved from Asturias to
 * Galicia).
 *
 * Only fantasy league screens provide it (the league's competition): a fantasy
 * league is scoped to one competition, so a player who left it will not score
 * any more points there. Elsewhere (e.g. season rosters, which also show past
 * seasons) there is no provider and cards only flag players without a team.
 */
const ReferenceCompetitionContext = createContext<string | undefined>(undefined)

export const ReferenceCompetitionProvider = ReferenceCompetitionContext.Provider

// eslint-disable-next-line react-refresh/only-export-components
export const useReferenceCompetitionId = () => useContext(ReferenceCompetitionContext)
